import { RxCoverageApplicationState } from '../RxCoverageApplication';

export const getIsContactSameAsInsured = (state: RxCoverageApplicationState) =>
  state.applicationForm['insuranceContact.sameAddressAsInsured'].value ===
  'yes';
